export default "/images/edit.svg?e0d538a7619897693f2e686b629ad139";